import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import { MoreVerticalIcon } from '../Layout/icons';

const Wrap = styled.div`
    position: relative;
    margin-left: auto;
    flex-shrink: 0;
`;

const TriggerBtn = styled.button`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 36px;
    height: 36px;
    padding: 0;
    border-radius: 8px;
    border: 1px solid ${({ theme }) => theme?.colors?.gray?.[200] || '#e5e7eb'};
    background: #fff;
    color: ${({ theme }) => theme?.colors?.gray?.[700] || '#374151'};
    cursor: pointer;
    &:hover:not(:disabled) {
        background: ${({ theme }) => theme?.colors?.gray?.[50] || '#f9fafb'};
    }
    &:disabled {
        opacity: 0.55;
        cursor: not-allowed;
    }
`;

const MenuOverlay = styled.div`
    position: fixed;
    inset: 0;
    z-index: 998;
    background: transparent;
`;

const Menu = styled.div`
    position: absolute;
    top: calc(100% + 6px);
    right: 0;
    min-width: 240px;
    z-index: 999;
    overflow: hidden;
    border-radius: 10px;
    border: 1px solid ${({ theme }) => theme?.colors?.gray?.[200] || '#e5e7eb'};
    background: #fff;
    box-shadow: 0 8px 24px rgba(0, 0, 0, 0.12);
`;

const MenuItem = styled.button`
    display: block;
    width: 100%;
    padding: 12px 16px;
    border: none;
    background: #fff;
    color: ${({ theme }) => theme?.colors?.gray?.[900] || '#111827'};
    font-size: 14px;
    font-weight: 500;
    text-align: left;
    cursor: pointer;
    &:not(:last-child) {
        border-bottom: 1px solid ${({ theme }) => theme?.colors?.gray?.[100] || '#f3f4f6'};
    }
    &:hover:not(:disabled) {
        background: ${({ theme }) => (theme?.colors?.primary?.light ? `${theme.colors.primary.light}18` : 'rgba(59, 89, 152, 0.08)')};
    }
    &:disabled {
        color: ${({ theme }) => theme?.colors?.gray?.[400] || '#9ca3af'};
        cursor: not-allowed;
    }
`;

export default function AddressFillOptionsMenu({
    disabled = false,
    requesterDisabled = false,
    templateDisabled = false,
    requesterLabel = 'Usar endereço do solicitante',
    onUseRequester,
    onUseTemplate,
}) {
    const [open, setOpen] = useState(false);

    useEffect(() => {
        if (!open) return undefined;
        const onKey = (e) => {
            if (e.key === 'Escape') setOpen(false);
        };
        document.addEventListener('keydown', onKey);
        return () => document.removeEventListener('keydown', onKey);
    }, [open]);

    const close = () => setOpen(false);

    const handleRequester = () => {
        close();
        onUseRequester?.();
    };

    const handleTemplate = () => {
        close();
        onUseTemplate?.();
    };

    return (
        <Wrap>
            <TriggerBtn
                type="button"
                aria-label="Opções"
                aria-haspopup="menu"
                aria-expanded={open}
                disabled={disabled}
                onClick={() => setOpen((v) => !v)}
                title="Opções"
            >
                <MoreVerticalIcon />
            </TriggerBtn>
            {open && (
                <>
                    <MenuOverlay onClick={close} aria-hidden />
                    <Menu role="menu" aria-label="Opções de endereço">
                        <MenuItem
                            type="button"
                            role="menuitem"
                            disabled={requesterDisabled}
                            onClick={handleRequester}
                        >
                            {requesterLabel}
                        </MenuItem>
                        <MenuItem
                            type="button"
                            role="menuitem"
                            disabled={templateDisabled}
                            onClick={handleTemplate}
                        >
                            Usar endereço recorrente
                        </MenuItem>
                    </Menu>
                </>
            )}
        </Wrap>
    );
}
